export default __webpack_public_path__ + "static/media/gamer.1e30dad1.png";